import { Box, Grid } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import Button from '../../../../components/button/button.component';
import { Link, useNavigate } from 'react-router-dom';
import Checkbox from '../../../../components/checkbox/checkbox.component';
import { CancelContext } from '../../../../contexts/cancellation.context';
import { addError, freshDeskReport, removeErrorConfirm } from '../../../../utils/generaFunctions';
import { addCoupon } from '../../../../utils/recurly.functions';

const OfferMain = () => {
    const {userInfo, setLoading} = useContext(CancelContext);
    const navigate = useNavigate();
    const [choice, setChoice] = useState(1);
    useEffect(()=>{
        if(choice!==null){
            removeErrorConfirm();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[choice]);
    return (
        <Grid container className='main-container'>
            <Grid container item className='flex-vertical' xs={12}>
                <div>
                    <Grid item className='title' xs={12}>
                        <h1>Wait, special price alert</h1>
                    </Grid>
                    <Grid item className='desc' xs={12}>
                        Continue your subscription at a super low price and keep enjoying all the amazing themed boxes.
                    </Grid>
                </div>
                <Grid item id='option-container'>
                    <Box className={`box ${choice? "selected":"not-selected"}`}>
                        <div className='small-header'>Yes! continue at <span className='strike-through'>$41.99</span> $31.99 / box</div>
                        <Checkbox checked={choice} large="true"/>
                    </Box>
                </Grid>
                <Grid item id='button-container'>
                    <Link 
                        className={`button-link`} 
                        onClick={()=>{
                            if(!choice){
                                addError(document.getElementById('option-container'), 'Select one of the options above first and then click continue');
                            } else{
                                setLoading(true);
                                addCoupon(userInfo.email, 'internal10_00').then((response)=>{
                                    freshDeskReport(userInfo.email, userInfo.name, "Prevented By Reduced Price", "Sys2.0: Prevented","Sys2.0: Prevented", "Sys2.0: Reduce price").then((data)=>{
                                        navigate("confirmed"+window.location.search);
                                    })
                                }).catch(()=>{
                                    navigate("confirmed"+window.location.search);
                                })
                                }
                        }}
                    ><Button text="confirm"></Button></Link>
                    <Link className={`button-link`} to={"../reason"+window.location.search}><Button className="btn-reverse" text={"Continue to cancel"}/></Link>
                </Grid>
                <Link className='go-back' to={'../'+window.location.search}>&lt;&lt; BACK TO PREVIOUS PAGE</Link>
            </Grid>
        </Grid>
    )
}

export default OfferMain;